import styled from "styled-components";

export const Header2 = styled.h2`
  color: ${({ theme }) => theme.colors.grey.dark};

  @media screen and (max-width: ${props => props.theme.breakpoints.sm}px) {
    font-size: 18px;
  }
`;

export const Link = styled.a`
  color: #333;
  text-decoration: none;
`;
